import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { ExpiredInformerItemFindInterface } from '@zaoblako/shared/modules/notification/dtos/informer/expired.informer.item.find.dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExpiredInformerService extends BaseService {
  protected baseUrl = '/basis/notification/expired-informer';

  public getExpiredObjects(): Observable<ExpiredInformerItemFindInterface[]> {
    return this.http.get<ExpiredInformerItemFindInterface[]>(this.baseUrl);
  }
}
